import { LegalPage, LegalSection } from "./LegalPage";

export const CookiePolicy = () => (
  <LegalPage title="Cookie Policy" testid="cookie-policy-page">
    <LegalSection title="1. Cosa sono i cookie">
      <p>
        I cookie sono piccoli file di testo che i siti visitati salvano sul
        tuo dispositivo per migliorare l'esperienza di navigazione, garantire
        il funzionamento tecnico del sito o raccogliere statistiche di
        utilizzo.
      </p>
    </LegalSection>

    <LegalSection title="2. Cookie tecnici (necessari)">
      <p>
        Questo sito utilizza cookie tecnici necessari al corretto
        funzionamento delle pagine e della sicurezza. Questi cookie non
        richiedono il tuo consenso e non vengono utilizzati per scopi di
        profilazione.
      </p>
    </LegalSection>

    <LegalSection title="3. Cookie analitici">
      <p>
        Il sito utilizza strumenti di analisi (PostHog e Google Analytics 4)
        per raccogliere statistiche aggregate sul traffico: pagine visitate,
        tipo di dispositivo e interazioni con i pulsanti principali (ad
        esempio i clic sul numero di telefono). Queste informazioni ci
        aiutano a capire come viene utilizzato il sito e a migliorarlo, e
        possono essere collegate alla misurazione delle campagne Google Ads.
      </p>
    </LegalSection>

    <LegalSection title="4. Cookie di marketing e profilazione">
      <p>
        Il sito utilizza il tag di Google Ads per la{" "}
        <strong className="text-zinc-200">misurazione delle conversioni</strong>{" "}
        delle campagne pubblicitarie (ad esempio per contare i clic sul numero
        di telefono). Non utilizziamo questi dati per mostrarti pubblicità
        personalizzata su questo sito. Per maggiori informazioni consulta{" "}
        <a
          href="https://policies.google.com/technologies/ads"
          target="_blank"
          rel="noopener noreferrer"
          className="text-amber-400 hover:text-amber-300"
        >
          l'informativa di Google
        </a>
        .
      </p>
    </LegalSection>

    <LegalSection title="5. Servizi di terze parti">
      <p>
        Il sito utilizza Google Fonts per la visualizzazione dei caratteri
        tipografici: durante il caricamento delle pagine il browser può
        comunicare con i server di Google. Per maggiori informazioni consulta
        l'informativa privacy di Google (
        <a
          href="https://policies.google.com/privacy"
          target="_blank"
          rel="noopener noreferrer"
          className="text-amber-400 hover:text-amber-300"
        >
          policies.google.com/privacy
        </a>
        ).
      </p>
    </LegalSection>

    <LegalSection title="6. Come gestire o disattivare i cookie">
      <p>
        Puoi gestire o eliminare i cookie direttamente dalle impostazioni del
        tuo browser. La disattivazione dei cookie tecnici potrebbe
        compromettere alcune funzionalità del sito. Di seguito le guide dei
        principali browser:
      </p>
      <ul className="list-disc space-y-2 pl-5">
        <li>Chrome: Impostazioni → Privacy e sicurezza → Cookie</li>
        <li>Safari: Preferenze → Privacy</li>
        <li>Firefox: Impostazioni → Privacy e sicurezza</li>
        <li>Edge: Impostazioni → Cookie e autorizzazioni sito</li>
      </ul>
    </LegalSection>

    <LegalSection title="7. Titolare e contatti">
      <p>
        Titolare del trattamento:{" "}
        <strong className="text-zinc-200">FIX ROMA H24</strong> — Via di Torre
        Morena 92, 00118 Roma (RM), P.IVA 13434831007. Per qualsiasi domanda
        sui cookie:{" "}
        <a href="mailto:fixromah24@libero.it" className="text-amber-400 hover:text-amber-300">
          fixromah24@libero.it
        </a>{" "}
        oppure{" "}
        <a href="tel:+390685902421" className="text-amber-400 hover:text-amber-300">
          06 8590 2421
        </a>
        .
      </p>
    </LegalSection>
  </LegalPage>
);
